/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ShiftTemplateDto } from '../models/ShiftTemplateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ShiftTemplateControllerService {
    /**
     * @param uuid
     * @returns ShiftTemplateDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<ShiftTemplateDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/shift-templates/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ShiftTemplateDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: ShiftTemplateDto,
    ): CancelablePromise<ShiftTemplateDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/shift-templates/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/shift-templates/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns ShiftTemplateDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<ShiftTemplateDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/shift-templates',
        });
    }
    /**
     * @param requestBody
     * @returns ShiftTemplateDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: ShiftTemplateDto,
    ): CancelablePromise<ShiftTemplateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/shift-templates',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
